import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Parse from './parse'
import event from './router/event'
import eventClosed from './router/eventClosed'
import user from './router/user'
import info from './router/info'
import message from './router/message'
import quizset from './router/quizset'
import tourism from './router/tourism'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        navName: 'home',
        sideNav: true,
        requiresAuth: true
      }
    },

    {
      path: '/login',
      component: () => import('@/views/Login.vue'),
      name: 'login',
      meta: {
        navName: 'login',
        sideNav: false
      }
    },

    ...event,
    ...eventClosed,
    ...user,
    ...info,
    ...message,
    ...quizset,
    ...tourism
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Parse.User.current()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
      return
    }
  }
  next()
})

export default router
